<template>
    <div class="vue-admin">
        <div class="header-banner"><h1>Add Person &mdash; Admin</h1></div>
        <div class="page-space">
            <div class="ui secondary segment">
                <form :class="'ui small form' + (error ? ' error': '')" @submit="saveModel($event)">
                    <div class="ui grid">
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.first_name ? ' error' : '')">
                                <label for="model-first_name">First Name</label>
                                <error-tag :error="fieldErrors.first_name" direction="below"></error-tag>
                                <input id="model-first_name" v-model="model.first_name" required>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.last_name ? ' error' : '')">
                                <label for="model-last_name">Last Name</label>
                                <error-tag :error="fieldErrors.last_name" direction="below"></error-tag>
                                <input id="model-last_name" v-model="model.last_name" required>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.title ? ' error' : '')">
                                <label for="model-title">Title</label>
                                <error-tag :error="fieldErrors.title" direction="below"></error-tag>
                                <input id="model-title" v-model="model.title" required>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.type ? ' error' : '')">
                                <label for="model-type">Type</label>
                                <error-tag :error="fieldErrors.type" direction="below"></error-tag>
                                <div class="select-arrow">
                                    <select id="model-type" v-model="model.type">
                                        <option value="">-</option>
                                        <option value="brokers">Broker</option>
                                        <option value="industrial">Industrial</option>
                                        <option value="management">Management</option>
                                        <option value="retail">Retail</option>
                                        <option value="team">Team</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.industry ? ' error' : '')">
                                <label for="model-industry">Industry</label>
                                <error-tag :error="fieldErrors.industry" direction="below"></error-tag>
                                <div class="select-arrow">
                                    <select id="model-industry" v-model="model.industry">
                                        <option value="">-</option>
                                        <option value="investment">Capital Markets</option>
                                        <option value="industrial">Industrial</option>
                                        <option value="office">Office</option>
                                        <option value="retail">Retail</option>
                                        <option value="multifamily">Multifamily</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.location ? ' error' : '')">
                                <label for="model-location">Location</label>
                                <error-tag :error="fieldErrors.location" direction="below"></error-tag>
                                <div class="select-arrow">
                                    <select id="model-location" v-model="model.location" required>
                                        <option value="Oklahoma City">Oklahoma City</option>
                                        <option value="Tulsa">Tulsa</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div class="ui segment secondary">
                                <label>Photo</label>
                                <p><small>Recommended file size is 500px wide by 334px tall.</small></p>
                                <div :class="'field' + (fieldErrors.photo ? ' error' : '')">
                                    <error-tag :error="fieldErrors.photo" direction="below"></error-tag>
                                    <input type="file" ref="photopicker" id="model-photo-upload" @change="imagePreview">
                                </div>
                                <div class="ui grid">
                                    <div class="eight wide column">
                                        <choose-file folder="people" :photo_only="true" v-on:picked="chooseExistingFile"></choose-file>
                                        <div class="ui divider"></div>
                                        <button v-if="model.photo || photoUpload" class="ui small grey button" type="button" v-on:click="clearPhoto" ><i class="erase icon"></i> Clear photo</button>
                                    </div>
                                    <div class="eight wide column">
                                        <img alt="default" :src="photoUpload ? photoUpload.preview : (model.photo ?model.photo.folder + model.photo.file:'/img/default.jpg?v=1')">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.vcard ? ' error' : '')">
                                <label for="model-vcard">vCard</label>
                                <error-tag :error="fieldErrors.vcard" direction="below"></error-tag>
                                <input id="model-vcard" ref="vcard" type="file" accept=".vcf">
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.office_phone ? ' error' : '')">
                                <label for="model-office_phone">Office Phone</label>
                                <error-tag :error="fieldErrors.office_phone" direction="below"></error-tag>
                                <input id="model-office_phone" v-model="model.office_phone">
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.cell_phone ? ' error' : '')">
                                <label for="model-cell_phone">Cell Phone</label>
                                <error-tag :error="fieldErrors.cell_phone" direction="below"></error-tag>
                                <input id="model-cell_phone" v-model="model.cell_phone">
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.email ? ' error' : '')">
                                <label for="model-email">Email Address</label>
                                <error-tag :error="fieldErrors.email" direction="below"></error-tag>
                                <input id="model-email" type="email" v-model="model.email">
                            </div>
                        </div>
                        <div class="eight wide column">
                            <div :class="'field' + (fieldErrors.custom_property_url ? ' error' : '')">
                            <label for="model-custom_property_url">Custom Property URL</label>
                            <error-tag :error="fieldErrors.custom_property_url" direction="below"></error-tag>
                            <input id="model-custom_property_url" v-model="model.custom_property_url">
                        </div>
                        </div>
                    </div>
                    <div :class="'field' + (fieldErrors.description ? ' error' : '')">
                        <label for="model-description">Description</label>
                        <error-tag :error="fieldErrors.description" direction="below"></error-tag>
                        <ckeditor id="model-description" v-model="model.description"></ckeditor>
                    </div>
                    <div class="ui segments">
                        <div class="ui segment">
                            <div :class="'field' + (fieldErrors.middle_section ? ' error' : '')">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" id="model-show_middle_section" v-model="model.middle_section.show">
                                    <label class="check" for="model-show_middle_section">Show Middle Section</label>
                                </div>
                                <error-tag :error="fieldErrors.middle_section" direction="left"></error-tag>
                            </div>
                        </div>
                        <div v-if="model.middle_section.show" class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.middle_section_title ? ' error' : '')">
                                <label for="model-middle_section_title">Middle Section Title</label>
                                <error-tag :error="fieldErrors.middle_section_title" direction="below"></error-tag>
                                <input id="model-middle_section_title" v-model="model.middle_section.title">
                            </div>
                            <table class="ui celled table">
                                <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Subtitle</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(card, index) in model.middle_section.cards">
                                    <td><input v-model="card.title"></td>
                                    <td><input v-model="card.subtitle"></td>
                                    <td>
                                        <i class="add circle icon green large clickable" v-on:click="addCardAfter(index)"></i>
                                        <i v-if="model.middle_section.cards.length > 1" class="minus circle icon red large clickable" v-on:click="removeCard(index)"></i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <!--<label for="middle_section_csv">Middle Section paste CSV</label>-->
                            <!--<textarea id="middle_section_csv" v-model="middle_section_csv"-->
                                      <!--placeholder="Paste here from the old site to parse the comma-separated data">-->
                            <!--</textarea>-->
                        </div>
                    </div>
                    <div class="ui segments">
                        <div class="ui segment">
                            <div :class="'field' + (fieldErrors.additional_section ? ' error' : '')">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" id="model-additional_section" v-model="model.additional_section.show">
                                    <label class="check" for="model-additional_section">Show Additional Section</label>
                                </div>
                                <error-tag :error="fieldErrors.additional_section" direction="left"></error-tag>
                            </div>
                        </div>
                        <div v-if="model.additional_section.show" class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.additional_section_title ? ' error' : '')">
                                <label for="model-additional_section_title">Additional Section Title</label>
                                <error-tag :error="fieldErrors.additional_section_title" direction="below"></error-tag>
                                <input id="model-additional_section_title" v-model="model.additional_section.title">
                            </div>
                            <div :class="'field' + (fieldErrors.additional_section_body ? ' error' : '')">
                                <label for="model-additional_section_body">Additional Section</label>
                                <error-tag :error="fieldErrors.additional_section_body" direction="below"></error-tag>
                                <ckeditor id="model-additional_section_body" v-model="model.additional_section.body"></ckeditor>
                            </div>
                        </div>
                    </div>
                    <div class="ui segments">
                        <div class="ui segment">
                            <div :class="'field' + (fieldErrors.investment_section ? ' error' : '')">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" id="model-show_investment_section" v-model="model.investment_section.show">
                                    <label class="check" for="model-show_investment_section">Show Investment Section</label>
                                </div>
                                <error-tag :error="fieldErrors.investment_section" direction="left"></error-tag>
                            </div>
                        </div>
                        <div v-if="model.investment_section.show" class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.investment_section_title ? ' error' : '')">
                                <label for="model-investment_section_title">Investment Section Title</label>
                                <error-tag :error="fieldErrors.investment_section_title" direction="below"></error-tag>
                                <input id="model-investment_section_title" v-model="model.investment_section.title">
                            </div>
                            <label>Investments Table Titles</label>
                            <div class="ui horizontal segments">
                                <div v-for="(header, index) in model.investment_section.headers" class="ui segment flex-center">
                                    <input v-model="model.investment_section.headers[index]" :placeholder="'Column '+(index+1)">
                                    <div class="narrow">
                                        <i class="add circle icon green large clickable" v-on:click="addInvestmentHeaderAfter(index)"></i>
                                        <i v-if="model.investment_section.headers.length > 1" class="minus circle icon red large clickable" v-on:click="removeInvestmentHeader(index)"></i>
                                    </div>
                                </div>
                            </div>
                            <!--<label for="investment_table_titles_csv">Investments Table Titles paste CSV</label>-->
                            <!--<input id="investment_table_titles_csv" v-model="investment_table_titles_csv"-->
                                      <!--placeholder="Paste here from the old site to parse the comma-separated data">-->
                            <label>Investments</label>
                            <table class="ui celled table">
                                <thead>
                                <tr>
                                    <th v-for="(header, column) in model.investment_section.headers">
                                        {{header?header:'Column '+(column+1)}}
                                    </th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in model.investment_section.rows">
                                    <td v-for="(header, column) in model.investment_section.headers">
                                        <input v-model="model.investment_section.rows[index][column]">
                                    </td>
                                    <td>
                                        <i class="add circle icon green large clickable" v-on:click="addInvestmentRowAfter(index)"></i>
                                        <i v-if="model.investment_section.rows.length > 1" class="minus circle icon red large clickable" v-on:click="removeInvestmentRow(index)"></i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <!--<label for="investment_csv">Investments paste CSV</label>-->
                            <!--<textarea id="investment_csv" v-model="investment_csv"-->
                                      <!--placeholder="Paste here from the old site to parse the comma-separated data">-->
                            <!--</textarea>-->
                        </div>
                    </div>

                    <div class="ui segments">
                        <div class="ui segment">
                            <div :class="'field' + (fieldErrors.featured_properties ? ' error' : '')">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" id="model-featured_properties" v-model="model.featured_properties.show">
                                    <label class="check" for="model-featured_properties">Show Featured Properties</label>
                                </div>
                                <error-tag :error="fieldErrors.featured_properties" direction="left"></error-tag>
                            </div>
                        </div>
                        <div v-if="model.featured_properties.show" class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.featured_properties ? ' error' : '')">
                                <label for="model-featured_properties_title">Featured Properties Title</label>
                                <error-tag :error="fieldErrors.featured_properties_title" direction="below"></error-tag>
                                <input id="model-featured_properties_title" v-model="model.featured_properties.title">
                            </div>
                            <div :class="'field' + (fieldErrors.featured_properties_body ? ' error' : '')">
                                <label for="model-featured_properties_body">Featured Properties</label>
                                <error-tag :error="fieldErrors.featured_properties_body" direction="below"></error-tag>
                                <ckeditor id="model-featured_properties_body" v-model="model.featured_properties.body"></ckeditor>
                            </div>
                        </div>
                    </div>

                    <div class="ui segments">
                        <div class="ui segment">
                            <div :class="'field' + (fieldErrors.external_links ? ' error' : '')">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" id="model-external_links" v-model="model.external_links.show">
                                    <label class="check" for="model-external_links">Show External Links</label>
                                </div>
                                <error-tag :error="fieldErrors.external_links" direction="left"></error-tag>
                            </div>
                        </div>
                        <div v-if="model.external_links.show" class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.external_links ? ' error' : '')">
                                <label for="model-external_links_title">External Links Title</label>
                                <error-tag :error="fieldErrors.external_links_title" direction="below"></error-tag>
                                <input id="model-external_links_title" v-model="model.external_links.title">
                            </div>
                            <div :class="'field' + (fieldErrors.external_links_body ? ' error' : '')">
                                <label for="model-external_links_body">External Links</label>
                                <error-tag :error="fieldErrors.external_links_body" direction="below"></error-tag>
                                <ckeditor id="model-external_links_body" v-model="model.external_links.body"></ckeditor>
                            </div>
                        </div>
                    </div>

                    <error-display v-if="error" :error="error"></error-display>
                    <p>
                        <button type="submit" :class="'ui small green submit button' + (saving?' loading ':'')">Save Person</button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import ErrorDisplay from "../errorDisplay";
    import ErrorTag from "../errorTag";
    import ChooseFile from "../chooseExistingFile";
    import Ckeditor from 'vue-ckeditor2';

    export default {
        components: {
            ErrorTag, ErrorDisplay, ChooseFile,Ckeditor},
        data: function(){
            return {
                model: {
                    first_name:'',
                    last_name:'',
                    title:'',
                    type:'',
                    industry:'',
                    location:'Oklahoma City',
                    photo: null,
                    office_phone: '',
                    cell_phone: '',
                    email: '',
                    description: '',
                    middle_section: {
                        show: false,
                        title: '',
                        cards: [{title:'',subtitle:''}],
                    },
                    additional_section: {
                        show: false,
                        title: '',
                        body: '',
                    },
                    investment_section: {
                        show: false,
                        title: '',
                        headers: ['',''],
                        rows: [
                            ['','']
                        ]
                    },
                    custom_property_url: '',
                    featured_properties: {
                        show: false,
                        title: '',
                        body: ''
                    },
                    external_links: {
                        show: false,
                        title: '',
                        body: ''
                    }
                },
                photoUpload: null,
                error: null,
                fieldErrors: {},
                saving: false
            };
        },
        mounted(){
            document.title = 'Add Person — Admin | ' + document.title.split(' | ').pop();
        },
        computed:{
            // middle_section_csv:{
            //     get(){
            //         return this.model.middle_section.cards.map(card=>card.title+','+card.subtitle).join('\n');
            //     },
            //     set(newValue){
            //         this.model.middle_section.cards = newValue.split('\n')
            //             .map(card=>{
            //                 let split = card.split(',');
            //                 return {title:split[0],subtitle:split[1]};
            //             });
            //     }
            // },
            // investment_table_titles_csv:{
            //     get(){
            //         return this.model.investment_section.headers.join(',');
            //     },
            //     set(newValue){
            //         this.model.investment_section.headers = newValue.split(',');
            //     }
            // },
            // investment_csv:{
            //     get(){
            //         return this.model.investment_section.rows
            //             .map(row=>row.map(r=>r && r.includes(',')?'"'+r+'"':r).join(',')).join('\n');
            //     },
            //     set(newValue){
            //         this.model.investment_section.rows = newValue.split('\n')
            //             .map(row=>row.match(/(".*?"|[^",]+)(?=,|$)/g)
            //                 .map(r=>r.slice(0,1)==='"'&&r.slice(-1)==='"'?r.slice(1,-1):r));
            //     }
            // }
        },
        methods: {
            addCardAfter(index){
                this.model.middle_section.cards.splice(index + 1, 0, {title:'',subtitle:''});
            },
            removeCard(index){
                this.model.middle_section.cards.splice(index, 1);
                if(this.model.middle_section.cards.length === 0){
                    this.model.middle_section.cards.push({title:'',subtitle:''});
                }
            },
            addInvestmentHeaderAfter(index){
                this.model.investment_section.headers.splice(index + 1, 0, '');
                this.model.investment_section.rows.forEach((row)=>{
                    row.splice(index + 1, 0, '');
                });
            },
            removeInvestmentHeader(index){
                this.model.investment_section.headers.splice(index, 1);
                this.model.investment_section.rows.forEach((row)=>{
                    row.splice(index, 1);
                });
                if(this.model.investment_section.headers.length === 0){
                    thtis.model.investment_section.headers.push('');
                    this.model.investment_section.rows.forEach((row)=>{
                        row.push('');
                    });
                }
            },
            addInvestmentRowAfter(index){
                this.model.investment_section.rows.splice(index + 1, 0,
                    Array(this.model.investment_section.headers.length - 1).fill(''));
            },
            removeInvestmentRow(index){
                this.model.investment_section.rows.splice(index, 1);
                if(this.model.investment_section.rows.length === 0){
                    this.model.investment_section.rows.push(
                        Array(this.model.investment_section.headers.length - 1).fill(''));
                }
            },
            chooseExistingFile(folder, file){
                this.$refs.photopicker.value = '';
                this.photoUpload = null;
                this.model.photo = {folder, file};
            },
            clearPhoto(){
                this.$refs.photopicker.value = '';
                this.photoUpload = null;
                this.model.photo = null;
                this.$forceUpdate();
            },
            saveModel(event){
                event.preventDefault();
                this.saving = true;
                this.fieldErrors = {};
                let data = new FormData();
                data.append('model',JSON.stringify(this.model));
                console.log(this.model);
                console.log(this.model.description);
                let options = {};
                if(this.photoUpload || this.$refs.vcard.files.length > 0)
                    options = {headers: { 'Content-Type': 'multipart/form-data' }};
                if(this.photoUpload) data.append('photo_upload',this.photoUpload.file);
                if(this.$refs.vcard.files.length > 0) data.append('vcard_upload',this.$refs.vcard.files[0]);
                axios.post('/admin/api/people', data, options)
                    .then((response)=>{
                        if(response.status === 200){
                            this.$router.push('/admin/people/'+response.data.id+'/edit');
                        } else {
                            this.error = {header:'Error: '+response.statusText,message:response.data}
                        }
                    }).catch((error)=>{
                        if(error.response){
                            if(error.response.status === 400){
                                this.fieldErrors = error.response.data.errors;
                            } else {
                                this.error = {header:'Error', message:error.response.statusText};
                            }
                        }
                    }).then(()=>{this.saving = false;});
            },
            imagePreview: function(){
                let input = this.$refs.photopicker;
                if(input.files[0]){
                    this.photoUpload = {file:input.files[0]};
                    let reader = new FileReader();
                    reader.onload = (e)=>{
                        this.photoUpload.preview = reader.result;
                        this.$forceUpdate();
                    };
                    reader.readAsDataURL(this.photoUpload.file);
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .flex-center{
        display: flex;
        align-items: center;
    }
    .narrow {
        width: 1.5em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/people/create.vue